module.exports = __webpack_public_path__ + "38eb9ca03786a07562ae8434fa69b97b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Light.svg
 ** module id = 914
 ** module chunks = 9
 **/